import { MessageItem } from "./MessageItem";

export function MessageList({ messages, isAdmin, onPinMessage, onReplyMessage, currentUserId }) {
  if (!messages) return null;

  return (
    <div className="space-y-4 p-4">
      {messages.map((message) => {
        // if (!message.id) {
        //   console.warn('Message missing ID:', message);
        // }
        
        return (
          <MessageItem
            key={message.id || `fallback-${Date.now()}-${Math.random()}`}
            message={message}
            isOwnMessage={message.userId === currentUserId}
            isAdmin={isAdmin}
            onPin={(duration) => onPinMessage(message, duration)}
            onReply={() => {
              // console.log('Replying to message:', message);
              onReplyMessage(message);
            }}
          />
        );
      })}
    </div>
  );
}